<div class="sider-menu account-sidebar">
  <p class="sider-section-title">{{ title }}</p>
  <ul nz-menu nzMode="inline">
    <li nz-menu-item *ngFor="let item of items" [nzSelected]="item._uiSelected">
      <a [routerLink]="item.path" class="account-sidebar-link">
        <app-account-icon [name]="item.icon" [size]="20"></app-account-icon>
        <span>{{ item.label }}</span>
      </a>
    </li>
  </ul>

  <div class="account-sidebar-bottom">
    <a class="account-sidebar-card" [routerLink]="otherCardLink">
      <span class="account-sidebar-card-icon"><app-account-icon [name]="otherCard.icon" [size]="20"></app-account-icon></span>
      <span class="account-sidebar-card-text">
        <span class="account-sidebar-card-title">{{ otherCard.title }}</span>
        <span class="account-sidebar-card-hint">{{ otherCard.hint }}</span>
      </span>
      <app-account-icon name="chevron" [size]="16"></app-account-icon>
    </a>
    <p class="account-sidebar-help">
      <app-account-icon name="headset" [size]="18"></app-account-icon>
      Need help? <a [href]="supportMailto">Contact Support</a>
    </p>
  </div>
</div>
